import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Redux 

import { setIsOpened, resetCreateFolder } from '../../../../../redux/features/doctor/Dashboard/documents/createFolder';

// Components 

import Action from '../actions/Action';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ShieldMoonIcon from '@mui/icons-material/ShieldMoon';
import DownloadIcon from '@mui/icons-material/Download';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import GridViewIcon from '@mui/icons-material/GridView';
import WrapTextOutlinedIcon from '@mui/icons-material/WrapTextOutlined';
import Button from '../../../../general/inputs/Button';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { setIsFileExplorerPopupOpened } from '../../../../../redux/features/doctor/Dashboard/consultation/consultation';

const ListMetaHeader: React.FC = () => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation();

    const colors = useAppSelector((state) => state.theme.colors); 

    const accountInfo = useAppSelector((state) => state.meta.accountInfo); 

    const directory = useAppSelector((state) => state.fileExplorer.directory);
    const selectedFile = useAppSelector((state) => state.fileExplorer.selectedFile);
    const selectedFolder = useAppSelector((state) => state.fileExplorer.selectedFolder);
    const currentFolder = useAppSelector((state) => state.fileExplorer.currentFolder); 
    const folderView = useAppSelector((state) => state.fileExplorer.folderView); 

    const isFileExplorerPopupOpened = useAppSelector((state) => state.consultation.isFileExplorerPopupOpened); 

    const [isCurrentFolderProtected, setIsCurrentFolderProtected] = useState(false); 
    const [isPatientOptionDisabled, setIsPatientOptionDisabled] = useState(true); 

    // -- 

    const closeFileExplorerPopup = () => { 

        dispatch(setIsFileExplorerPopupOpened(false)); 

    }; 

    // -- 

    useEffect(() => { 

        if (selectedFolder?.relatedPatient || selectedFile?.relatedPatient) { 

            setIsPatientOptionDisabled(false); 

        } else if (directory.startsWith('Patients/')) { 

            setIsPatientOptionDisabled(false); 

        } else { 

            setIsPatientOptionDisabled(true); 

        }; 

    },[selectedFolder, selectedFile, directory]); 

    // -- 

    useEffect(() => { 

        if (((directory === 'Patients') || (directory === 'Downloads'))) { 

            setIsCurrentFolderProtected(true); 

        } else if ((directory?.includes('Shared'))) { 

            setIsCurrentFolderProtected(true); 

        } else if (currentFolder?.uploadedBy) {
            
            if (currentFolder?.uploadedBy != accountInfo?._id) { 

                setIsCurrentFolderProtected(true); 

            } else { 

                setIsCurrentFolderProtected(false); 
            }; 

        } else { 

            setIsCurrentFolderProtected(false); 

        };

    },[directory, currentFolder, accountInfo]); // Added dependencies

    // --

    return (

        <Box style={{ 
            display: 'flex', 
            flexDirection: 'row',
            alignItems: 'center', 
            justifyContent: 'space-between', 
            width: '100%',
            height: '70%', 
            fontSize: 20,
            paddingLeft: 1, // Add padding
            paddingRight: 1,
        }}>

            <Box
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    overflowX: 'auto', // Allow horizontal scroll on this side too
                    overflowY: 'hidden',
                    flexWrap: 'nowrap',
                }}
            >

                <Action title={'newFolder'} iconColor={colors?.main} action={'createFolder'} type='default' disabled={isCurrentFolderProtected}>
                    <AddCircleOutlineIcon /> 
                </Action>

                {/* <Action title={'uploadFile'} iconColor={colors?.main} action={'uploadFile'} type='default' disabled={isCurrentFolderProtected}>
                    <DownloadIcon /> 
                </Action> */}

                {/* <Action title={'patientInfo'} iconColor={colors?.main} action={'patientInfo'} type='default' disabled={isPatientOptionDisabled}>
                    <AccountCircleIcon /> 
                </Action> */}

                <Action title={'refresh'} iconColor={colors?.main} action={'refreshFileExplorer'} type='default'>
                    <RefreshIcon /> 
                </Action>

                <Action title={'changeView'} iconColor={colors?.main} action={'changeFolderView'} type='default'>
                    { folderView === 'row' ? <WrapTextOutlinedIcon /> : <GridViewIcon />}
                </Action>

                <Action title={'trashBin'} iconColor={colors?.main} action={'goToTrash'} type='default'>
                    <Box component="img" sx={{ width: 20 }} src={require('../../../../../assets/icons/files/bin.png')} />
                </Action>

            </Box>

            <Box
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    height: '100%',
                    flexShrink: 0, // Prevent shrinking of the close button container
                }}
            >

                {isFileExplorerPopupOpened && 
                    <Button 
                        title={'close'}
                        icon={<CloseOutlinedIcon sx={{ color: 'white', fontSize: 18 }} />}
                        triggerFunction={closeFileExplorerPopup}
                        extraStyle={{ 
                            margin: 0, 
                            // marginRight: 3, // Remove right margin if padding is added to parent
                            backgroundColor: 'rgba(232, 98, 30, 0.8)',
                            '&:hover': { 
                                color: 'white',
                                backgroundColor: 'rgb(232, 98, 30)'
                            }
                        }}
                    />}

            </Box>



        </Box>

    );

};

export default ListMetaHeader;